export default "__VITE_ASSET__5598f388__"